<tudi-menu></tudi-menu>
<div class="mt-3">
  <button pButton label="logout" (click)="logout()"></button>
</div>
<div class="mt-3">
  Version: 0.9.2
</div>